import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastController } from '@ionic/angular';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-validation-summary',
  templateUrl: './validation-summary.component.html',
  styleUrls: ['./validation-summary.component.scss'],
})
export class ValidationSummaryComponent implements OnInit {

  hasValidRecords = false;
  hasInvalidRecords = false;
  showProceedActions = false;

  constructor(
    public dialogRef: MatDialogRef<ValidationSummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastController: ToastController
  ) { }


  ngOnInit() {
    const valid = Number(this.data?.validRecords) || 0;
    const invalid = Number(this.data?.invalidRecords) || 0;

    this.hasValidRecords = valid > 0;
    this.hasInvalidRecords = invalid > 0;

    this.showProceedActions = this.hasValidRecords && !this.hasInvalidRecords;
  }

async downloadUpdatedRecords() {
  const updateList = this.data?.updateList;

  if (!updateList || updateList.length === 0) {
    const toast = await this.toastController.create({
      message: 'No updated records available to download',
      duration: 3000,
      position: 'bottom',
      cssClass: 'brand-toast'
    });
    await toast.present();
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Update Summary');

  // ✅ SAME HEADER CONFIG STYLE
  const headerConfig = [
    { key: 'folioNo', label: 'Folio No' },
    { key: 'applicationNo', label: 'Application No' },
    { key: 'status', label:'Status'},
    { key: 'investorName', label: 'Investor Name' },
    { key: 'pan', label: 'PAN' },
    { key: 'fundId', label: 'Fund ID' },
    { key: 'fundName', label: 'Fund Name' },
    { key: 'distributorARN', label: 'Distributor ARN' },
    { key: 'distributorName', label: 'Distributor Name' },
    { key: 'existingRMName', label: 'Existing RM Name' },
    { key: 'existingRMEmail', label: 'Existing RM Email' },
    { key: 'existingRMCode', label: 'Existing RM Code' },
    { key: 'newRMName', label: 'New RM Name' },
    { key: 'newRMEmail', label: 'New RM Email' },
    { key: 'newRMCode', label: 'New RM Code' },
    { key: 'existingCXOName', label: 'Existing CXO Name' },
    { key: 'existingCXOEmail', label: 'Existing CXO Email' },
    { key: 'existingCXOMobile', label: 'Existing CXO Mobile' },
    { key: 'newCXOName', label: 'New CXO Name' },
    { key: 'newCXOEmail', label: 'New CXO Email' },
    { key: 'newCXOMobile', label: 'New CXO Mobile' },
    { key: 'recordStatus', label: 'Record Status' },
    { key: 'reason', label: 'Reason'}
  ];

  // ✅ HEADER ROW
  const headerRow = worksheet.addRow(
    headerConfig.map(h => h.label)
  );

  // ✅ HEADER STYLING
  headerRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD9D9D9' }
    };
    cell.alignment = { horizontal: 'left' };
  });

  // ✅ DATA ROWS
  updateList.forEach(row => {
    const dataRow = worksheet.addRow(
      headerConfig.map(h => row[h.key] ?? '')
    );

    dataRow.eachCell(cell => {
      cell.alignment = { horizontal: 'left' };
    });
  });

  // ✅ AUTO WIDTH
  worksheet.columns.forEach(col => {
    let max = 12;
    col.eachCell({ includeEmpty: true }, cell => {
      const len = cell.value?.toString().length || 0;
      max = Math.max(max, len);
    });
    col.width = Math.min(max + 4, 40);
  });

  const buffer = await workbook.xlsx.writeBuffer();

  const fileName = this.data?.fileName
    ? `Update_Summary_${this.data.fileName}.xlsx`
    : 'Update_Summary.xlsx';

  saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }),
    fileName
  );

  const toast = await this.toastController.create({
    message: 'Update summary downloaded successfully',
    duration: 3000,
    position: 'bottom',
    cssClass: 'brand-toast'
  });
  await toast.present();
}

  onYes() {
    this.dialogRef.close({ proceed: true });
  }

  onNo() {
    this.dialogRef.close({ clearFile: true });
  }

}
